import React from "react"
import styles from "./card.module.css"

const Card = (props) => {
    const getColorClass = () => {
        switch(props.color) {
            case 'orange':
                return styles.orange;
            case 'gray':
                return styles.gray;
            case 'blue':
                return styles.blue;
            default:
                return styles.blue;
        }
    }

    const cardHeight = props.cardTop ? "103px" : "180px";

    return (
        <a 
            target="_placeholder" 
            rel="noopener noreferrer" 
            href={props.link}
            className={styles.linkContainer}
            style={{ height: cardHeight }}
        >
            <div 
                className={`${styles.card} ${getColorClass()}`}
                style={{ 
                    height: cardHeight,
                    justifyContent: props.cardTop ? "center" : "flex-start" 
                }}
            >
                <h2 className={styles.cardHeader}>{props.title}</h2>
                {props.children && (
                    <div className={styles.cardContent}>
                        {props.children}
                    </div>
                )}
            </div>
        </a>
    )
}

export default Card;